import { render, staticRenderFns } from "./item-autocomplete.vue?vue&type=template&id=4a45f37e&scoped=true"
import script from "./item-autocomplete.vue?vue&type=script&lang=js"
export * from "./item-autocomplete.vue?vue&type=script&lang=js"
import style0 from "./item-autocomplete.vue?vue&type=style&index=0&id=4a45f37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a45f37e",
  null
  
)

export default component.exports